import { t } from 'i18next';

export function getAccountTypeLabel(accountType) {
    const accountTypeLabels = {
        SERVICE: t('Service user'),
        SHIPPER: t('Shipper'),
        PROVIDER: t('Provider'),
        CARRIER: t('Carrier'),
        ADMIN: t('Admin staff'),
    };
    return accountTypeLabels[accountType] || t('Unknown');
}

export function getCustomerCompanyName(user, customerId) {
    if (user?.role !== 'PROVIDER' || !customerId) {
        return undefined;
    }
    return user?.customers?.find((customer) => customer.id === customerId)?.company;
}
